import React, { useState, useEffect, useRef } from "react";
import "./../../../assets/css/purchase/form.css";

import moment from "moment";

import Breadcrumbs from "../../components/Breadcrumbs";
import Sidebar from "../../components/Sidebar";
import ItemModal from "../../components/Modal/ItemModal";
import { exportHtmlTableToExcel } from "../../../utils/ExportUtils";
import { getAlert, getDataWithJoin, getData } from "../../../utils/SamuiUtils";
import { useEscapeClose } from "../../../utils/SamuiUtils";

const MaterialReport = () => {
  const [name, setName] = useState(null);
  const [searchCriteria, setSearchCriteria] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchType, setSearchType] = useState("byItemCode");

  const [selectedItems, setSelectedItems] = useState([]);
  const [itemCodeFrom, setItemCodeFrom] = useState("");
  const [itemCodeTo, setItemCodeTo] = useState("");
  const [showItemModal, setShowItemModal] = useState(false);
  const [itemsList, setItemsList] = useState([]);

  const [warehouseList, setWarehouseList] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState("");
  const [showWarehouseModal, setShowWarehouseModal] = useState(false);

  const [selectedRow, setSelectedRow] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(16);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const [isExporting, setIsExporting] = useState(false);
  const tableRef = useRef(null);

  const renderPageNumbers = () => {
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const pages = [];
    const maxVisiblePages = 5;
    const range = 2;

    if (totalPages > maxVisiblePages) {
      pages.push(
        <li
          key={1}
          className={`paginate_button page-item ${currentPage === 1 ? "active" : ""
            }`}
        >
          <a href="#" className="page-link" onClick={() => setCurrentPage(1)}>
            1
          </a>
        </li>
      );

      if (currentPage - range > 2) {
        pages.push(
          <li key="ellipsis-start" className="paginate_button page-item">
            <a href="#" className="page-link">
              ...
            </a>
          </li>
        );
      }

      for (
        let i = Math.max(currentPage - range, 2);
        i <= Math.min(currentPage + range, totalPages - 1);
        i++
      ) {
        pages.push(
          <li
            key={i}
            className={`paginate_button page-item ${currentPage === i ? "active" : ""
              }`}
          >
            <a href="#" className="page-link" onClick={() => setCurrentPage(i)}>
              {i}
            </a>
          </li>
        );
      }

      if (currentPage + range < totalPages - 1) {
        pages.push(
          <li key="ellipsis-end" className="paginate_button page-item">
            <a href="#" className="page-link">
              ...
            </a>
          </li>
        );
      }

      pages.push(
        <li
          key={totalPages}
          className={`paginate_button page-item ${currentPage === totalPages ? "active" : ""
            }`}
        >
          <a
            href="#"
            className="page-link"
            onClick={() => setCurrentPage(totalPages)}
          >
            {totalPages}
          </a>
        </li>
      );
    } else {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`paginate_button page-item ${currentPage === i ? "active" : ""
              }`}
          >
            <a href="#" className="page-link" onClick={() => setCurrentPage(i)}>
              {i}
            </a>
          </li>
        );
      }
    }

    return pages;
  };

  const handleExport = async () => {
    if (!filteredData || filteredData.length === 0) {
      getAlert("FAILED", "ไม่มีข้อมูลสำหรับ Export");
      return;
    }

    if (!tableRef.current) {
      getAlert("FAILED", "ไม่พบตารางข้อมูลสำหรับ Export");
      return;
    }

    try {
      setIsExporting(true);
      const fileName = `material-report_${moment().format(
        "YYYYMMDD_HHmmss"
      )}.xlsx`;
      const headerLines = [
        name || "รายงานวัสดุคงเหลือ",
        searchType === "byItemCode"
          ? `ช่วงรหัสวัสดุ: ${itemCodeFrom || "-"} ถึง ${itemCodeTo || "-"}`
          : selectedWarehouse
          ? `คลัง: ${
              warehouseList.find((w) => w.WH_Id === selectedWarehouse)?.WH_Code ||
              "-"
            } - ${
              warehouseList.find((w) => w.WH_Id === selectedWarehouse)?.WH_Name ||
              "-"
            }`
          : "",
      ];
      await exportHtmlTableToExcel(tableRef.current, {
        sheetName: name || "รายงานวัสดุคงเหลือ",
        fileName,
        headerLines,
      });
    } catch (error) {
      console.error("Export material report error:", error);
      getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    } finally {
      setIsExporting(false);
    }
  };

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    setName("11. รายงานวัสดุคงเหลือ");
    setSearchCriteria({});
    setFilteredData([]);
    setSelectedItems([]);
    setItemCodeFrom("");
    setItemCodeTo("");
    setSelectedWarehouse("");

    await loadWarehouseList();
    await loadItemsList();
  };

  const loadWarehouseList = async () => {
    try {
      const compId = localStorage.getItem("company") || "";
      let response = null;

      try {
        response = await getDataWithJoin(
          "WH_Id, WH_Code, WH_Name",
          "View_Set_WH",
          "",
          `WHERE Comp_Id = '${compId}' ORDER BY WH_Code ASC`
        );
      } catch (error1) {
        try {
          response = await getData(
            "Tb_Set_WH",
            `Comp_Id = '${compId}' ORDER BY WH_Code ASC`
          );
        } catch (error2) { }
      }

      if (response && response.length > 0) {
        setWarehouseList(response);
      } else {
        setWarehouseList([]);
        getAlert("ERROR", "An Error Occurred While Querying The Database.");
      }
    } catch (error) {
      setWarehouseList([]);
      getAlert("ERROR", "An Error Occurred While Querying The Database.");
    }
  };

  const loadItemsList = async () => {
    try {
      const compId = localStorage.getItem("company") || "";
      let response = null;

      try {
        response = await getDataWithJoin(
          "Item_Id, Item_Code, Item_Name",
          "API_0002_Set_Item",
          "",
          `WHERE Comp_Id = '${compId}' ORDER BY Item_Code ASC`
        );
      } catch (error1) {
        try {
          response = await getData(
            "API_0002_Set_Item",
            `Comp_Id = '${compId}' ORDER BY Item_Code ASC`
          );
        } catch (error2) {
          try {
            response = await getData(
              "Tb_Set_Item",
              `Comp_Id = '${compId}' ORDER BY Item_Code ASC`
            );
          } catch (error3) {
            try {
              response = await getData(
                "View_Set_Item",
                `Comp_Id = '${compId}' ORDER BY Item_Code ASC`
              );
            } catch (error4) { }
          }
        }
      }

      if (response && response.length > 0) {
        setItemsList(response);
      } else {
        setItemsList([]);
        getAlert("ERROR", "An Error Occurred While Querying The Database.");
      }
    } catch (error) {
      setItemsList([]);
      getAlert("ERROR", "An Error Occurred While Querying The Database.");
    }
  };

  const handleSearchTypeChange = (type) => {
    setSearchType(type);
    setFilteredData([]);
    setSelectedItems([]);
    setItemCodeFrom("");
    setItemCodeTo("");
    setSelectedWarehouse("");
  };

  const handleSearch = async () => {
    try {
      setFilteredData([]);

      if (searchType === "byItemCode") {
        await searchByItemCode();
      } else if (searchType === "byWarehouse") {
        await searchByWarehouse();
      }
    } catch (error) {
      getAlert("ERROR", "An Error Occurred While Querying The Database.");
    }
  };

  const searchByItemCode = async () => {
    const companyData = localStorage.getItem("company");
    const compId = companyData ? companyData : "";

    let whereCondition = "";

    if (selectedItems.length > 0) {
      const itemIds = selectedItems
        .map((item) => `Item_Id = '${item.Item_Id}'`)
        .join(" OR ");
      whereCondition = `WHERE (${itemIds}) AND Comp_Id = '${compId}'`;
    } else if (itemCodeFrom && itemCodeTo) {
      whereCondition = `WHERE ITM.Item_Code BETWEEN '${itemCodeFrom}' AND '${itemCodeTo}' AND ITM.Comp_Id = '${compId}'`;
    } else {
      getAlert("WARNING", "กรุณาเลือกสินค้าหรือใส่ช่วงรหัสสินค้า");
      return;
    }

    const selectFields = `ITM.Item_Code, ITM.Item_Name, ITM.Reft_ItemOnhand`;
    const fromTable = `API_0002_Set_Item ITM`;
    const joinTables = ``;

    const response = await getDataWithJoin(
      selectFields,
      fromTable,
      joinTables,
      whereCondition
    );

    setFilteredData(response || []);
  };

  const searchByWarehouse = async () => {
    if (!selectedWarehouse) {
      getAlert("WARNING", "กรุณาเลือกคลัง");
      return;
    }

    const companyData = localStorage.getItem("company");
    const compId = companyData ? companyData : "";
    const whereCondition = `WHERE ITM.WH_Id = '${selectedWarehouse}' AND ITM.Comp_Id = '${compId}'`;
    const selectFields = `ITM.Item_Code, ITM.Item_Name, ITM.Item_Onhand`;
    const fromTable = `API_1101_WH_ITEM_ONHAND ITM`;
    const joinTables = ``;

    const response = await getDataWithJoin(
      selectFields,
      fromTable,
      joinTables,
      whereCondition
    );

    setFilteredData(response || []);
  };

  const handleItemClose = () => {
    setShowItemModal(false);
  };

  const onRowSelectItem = (selectedItemsFromModal) => {
    setSelectedItems(selectedItemsFromModal);
    setShowItemModal(false);
  };

  return (
    <>
      <Sidebar />
      <div className="main-panel">
        <div className="container">
          <div className="page-inner">
            <div className="page-header d-flex justify-content-between align-items-center">
              <Breadcrumbs
                page={name}
                items={[
                  { name: "รายงาน", url: "/reports" },
                  { name: name, url: "/material-report" },
                ]}
              />
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h4>เงื่อนไขการค้นหา</h4>
                  </div>
                  <div className="card-body">
                    <div className="row mb-3">
                      <div className="col-md-12">
                        <label className="form-label">ประเภทการค้นหา:</label>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="searchType"
                            id="byItemCode"
                            checked={searchType === "byItemCode"}
                            onChange={() =>
                              handleSearchTypeChange("byItemCode")
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="byItemCode"
                          >
                            ค้นหาตามรหัสวัสดุ
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="searchType"
                            id="byWarehouse"
                            checked={searchType === "byWarehouse"}
                            onChange={() =>
                              handleSearchTypeChange("byWarehouse")
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="byWarehouse"
                          >
                            ค้นหาตามยอดคงเหลือแต่ละคลัง
                          </label>
                        </div>
                      </div>
                    </div>

                    {searchType === "byItemCode" && (
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>สินค้าที่เลือก:</label>
                            <div className="d-flex">
                              <button
                                type="button"
                                className="btn text-white"
                                style={{ backgroundColor: "#EF6C00" }}
                                onClick={() => setShowItemModal(true)}
                                disabled={itemsList.length === 0}
                              >
                                <i className="fas fa-search" /> เลือกสินค้า
                              </button>
                              <span className="ms-2 align-self-center">
                                ({selectedItems.length} รายการ)
                              </span>
                            </div>
                            {selectedItems.length > 0 && (
                              <div className="mt-2">
                                <small className="text-muted">
                                  {selectedItems
                                    .slice(0, 3)
                                    .map((item) => item.Item_Name)
                                    .join(", ")}
                                  {selectedItems.length > 3 && "..."}
                                </small>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label>รหัสสินค้าเริ่มต้น:</label>
                            <input
                              type="text"
                              className="form-control"
                              value={itemCodeFrom}
                              onChange={(e) => setItemCodeFrom(e.target.value)}
                              placeholder="เริ่มต้น"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label>รหัสสินค้าสิ้นสุด:</label>
                            <input
                              type="text"
                              className="form-control"
                              value={itemCodeTo}
                              onChange={(e) => setItemCodeTo(e.target.value)}
                              placeholder="สิ้นสุด"
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {searchType === "byWarehouse" && (
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>เลือกคลัง:</label>
                            <button
                              type="button"
                              className="btn text-white d-block"
                              style={{ backgroundColor: "#EF6C00" }}
                              onClick={() => setShowWarehouseModal(true)}
                              disabled={warehouseList.length === 0}
                            >
                              <i className="fas fa-warehouse" /> เลือกคลัง (
                              {warehouseList.length} คลัง)
                            </button>
                            {selectedWarehouse && (
                              <div className="mt-2">
                                <small className="text-muted">
                                  คลังที่เลือก:{" "}
                                  {
                                    warehouseList.find(
                                      (w) => w.WH_Id === selectedWarehouse
                                    )?.WH_Code
                                  }{" "}
                                  -{" "}
                                  {
                                    warehouseList.find(
                                      (w) => w.WH_Id === selectedWarehouse
                                    )?.WH_Name
                                  }
                                </small>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="col-md-12 d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-lg shadow text-white"
                        style={{
                          width: "10%",
                          marginRight: "20px",
                          backgroundColor: "#EF6C00",
                          fontSize: "16px",
                        }}
                        onClick={handleSearch}
                      >
                        <i className="fas fa-search" /> ค้นหา
                      </button>
                      <button
                        type="button"
                        className="btn btn-lg shadow text-white"
                        style={{
                          width: "10%",
                          marginRight: "20px",
                          backgroundColor: "#EF6C00",
                          fontSize: "16px",
                        }}
                        onClick={handleExport}
                        disabled={isExporting || filteredData.length === 0}
                      >
                        <i className="fas fa-file-excel" />{" "}
                        {isExporting ? "กำลังส่งออก..." : "Export"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-lg shadow text-white"
                        style={{
                          width: "10%",
                          backgroundColor: "#EF6C00",
                          fontSize: "16px",
                        }}
                        onClick={initialize}
                      >
                        <i className="fas fa-undo" /> เริ่มใหม่
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12 mt-4">
                <div className="card">
                  <div className="card-header">
                    <h4>ผลการค้นหา</h4>
                  </div>
                  <div className="card-body">
                    <div
                      className="table-responsive"
                      style={{ maxHeight: "550px", overflowY: "auto" }}
                    >
                      <table
                        className="table table-striped table-hover"
                        ref={tableRef}
                      >
                        <thead className="thead-dark">
                          <tr>
                            <th className="text-center">รหัสวัสดุ</th>
                            <th className="text-center">ชื่อวัสดุ</th>
                            <th className="text-center">จำนวนคงเหลือ</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems.length > 0 ? (
                            currentItems.map((data, index) => {
                              const rowId = data.Item_Code || index + 1;
                              return (
                                <tr
                                  key={rowId}
                                  style={{
                                    cursor: "pointer",
                                    backgroundColor:
                                      selectedRow === rowId
                                        ? "#f8f9fa"
                                        : "transparent",
                                    transition: "background-color 0.3s ease",
                                  }}
                                  onClick={() => setSelectedRow(rowId)}
                                >
                                  <td className="text-center">
                                    {data.Item_Code || "-"}
                                  </td>
                                  <td className="text-left">
                                    {data.Item_Name || "-"}
                                  </td>
                                  <td className="text-center">
                                    {(() => {
                                      const value =
                                        searchType === "byItemCode"
                                          ? data.Reft_ItemOnhand || "0"
                                          : data.Item_Onhand || "0";

                                      // แปลงเป็นตัวเลขและเพิ่ม comma
                                      const numValue = parseFloat(value);
                                      return isNaN(numValue)
                                        ? "0"
                                        : numValue.toLocaleString();
                                    })()}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center">
                                <h5>ไม่พบข้อมูล</h5>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="row mt-3">
                      <div className="col-12 d-flex justify-content-end">
                        <div
                          className="dataTables_paginate paging_simple_numbers"
                          id="basic-datatables_paginate"
                        >
                          <ul className="pagination">
                            <li
                              className={`paginate_button page-item previous ${currentPage === 1 ? "disabled" : ""
                                }`}
                            >
                              <a
                                href="#"
                                className="page-link"
                                onClick={() => setCurrentPage(currentPage - 1)}
                              >
                                Previous
                              </a>
                            </li>
                            {renderPageNumbers()}
                            <li
                              className={`paginate_button page-item next ${currentPage ===
                                  Math.ceil(filteredData.length / itemsPerPage)
                                  ? "disabled"
                                  : ""
                                }`}
                            >
                              <a
                                href="#"
                                className="page-link"
                                onClick={() => setCurrentPage(currentPage + 1)}
                              >
                                Next
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ItemModal
        formDetailList={[]}
        showItemModal={showItemModal}
        handleItemClose={handleItemClose}
        itemDataList={itemsList}
        onRowSelectItem={onRowSelectItem}
      />

      <WarehouseModal
        showWarehouseModal={showWarehouseModal}
        handleWarehouseClose={() => setShowWarehouseModal(false)}
        warehouseDataList={warehouseList}
        onRowSelectWarehouse={(warehouse) => {
          setSelectedWarehouse(warehouse.WH_Id);
          setShowWarehouseModal(false);
        }}
      />
    </>
  );
};

const WarehouseModal = ({
  showWarehouseModal,
  handleWarehouseClose,
  warehouseDataList,
  onRowSelectWarehouse,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredWarehouseDataList, setFilteredWarehouseDataList] =
    useState(warehouseDataList);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);

  useEscapeClose(showWarehouseModal, handleWarehouseClose);

  useEffect(() => {
    if (showWarehouseModal) {
      setSearchTerm("");
      setSelectedWarehouse(null);
    }
  }, [showWarehouseModal]);

  useEffect(() => {
    setFilteredWarehouseDataList(
      warehouseDataList.filter(
        (warehouse) =>
          warehouse.WH_Code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          warehouse.WH_Name?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, warehouseDataList]);

  const handleWarehouseSelect = (warehouse) => {
    setSelectedWarehouse(warehouse);
  };

  const handleConfirm = () => {
    if (selectedWarehouse) {
      onRowSelectWarehouse(selectedWarehouse);
    } else {
      alert("กรุณาเลือกคลัง");
    }
  };

  return (
    <>
      <div
        className={`modal ${showWarehouseModal ? "show" : ""}`}
        style={{ display: showWarehouseModal ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">รายชื่อคลัง</h5>
              <button
                type="button"
                className="close"
                onClick={handleWarehouseClose}
              >
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="ค้นหา รหัสคลัง หรือ ชื่อคลัง"
                  value={searchTerm || ""}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div
                className="table-responsive"
                style={{ maxHeight: "450px", overflowY: "auto" }}
              >
                <table className="table table-striped table-hover">
                  <thead className="thead-dark">
                    <tr>
                      <th className="text-center" style={{ width: "5%" }}>
                        เลือก
                      </th>
                      <th className="text-center" style={{ width: "25%" }}>
                        รหัสคลัง
                      </th>
                      <th className="text-center" style={{ width: "70%" }}>
                        ชื่อคลัง
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredWarehouseDataList.length > 0 ? (
                      filteredWarehouseDataList.map((warehouse, index) => (
                        <tr
                          key={warehouse.WH_Id || index + 1}
                          onClick={() => handleWarehouseSelect(warehouse)}
                          style={{
                            cursor: "pointer",
                            backgroundColor:
                              selectedWarehouse?.WH_Id === warehouse.WH_Id
                                ? "#f8f9fa"
                                : "transparent",
                            transition: "background-color 0.3s ease",
                          }}
                        >
                          <td className="text-center">
                            <input
                              type="radio"
                              name="warehouse"
                              checked={
                                selectedWarehouse?.WH_Id === warehouse.WH_Id
                              }
                              onChange={() => handleWarehouseSelect(warehouse)}
                              onClick={(e) => e.stopPropagation()}
                            />
                          </td>
                          <td className="text-center">{warehouse.WH_Code}</td>
                          <td className="text-left">{warehouse.WH_Name}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          ไม่พบข้อมูล
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn text-white"
                style={{ backgroundColor: "#EF6C00" }}
                onClick={handleConfirm}
              >
                ยืนยัน
              </button>
              <button
                className="btn btn-secondary"
                onClick={handleWarehouseClose}
              >
                ปิด
              </button>
            </div>
          </div>
        </div>
      </div>
      {showWarehouseModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default MaterialReport;
